/**
 * Shared helpers for the editor's optimistic-update transforms (plan D8).
 *
 * `reindex` is the invariant every structural op restores: day `ordinal` and
 * stop `ordinal` are dense and match array position, so the optimistic
 * snapshot the editor renders looks exactly like the server truth that
 * replaces it. Extracted verbatim from `ItineraryEditor` (#314) so the stop
 * and plan op hooks can share one copy.
 */

import type { SerializedItinerary } from './itineraryTypes';

let opSeq = 0;

/** Monotonic id for a queued op (and for the `tmp-` ids of optimistic rows). */
export const nextOpId = () => `op-${Date.now()}-${opSeq++}`;

export const findDay = (snap: SerializedItinerary, dayId: string) =>
  snap.days.find((d) => d._id === dayId);

export const reindex = (snap: SerializedItinerary): SerializedItinerary => ({
  ...snap,
  days: snap.days.map((d, di) => ({
    ...d,
    ordinal: di,
    stops: d.stops.map((s, si) => ({ ...s, ordinal: si })),
  })),
});
